import { rateFromPercentInput } from "@/lib/commissionRate";

/** Optional scoped sales agent sent with an activity / house create request. */
export interface SalesAgentAssignment {
  sales_agent_user_id: string;
  sales_agent_commission_rate: number;
}

export type SalesAgentCommissionValidation =
  { ok: true; assignment: SalesAgentAssignment | null } | { ok: false };

/**
 * Sales-agent step of the create wizards: picking an agent is optional, but once
 * one is picked their cut must be a valid percent.
 */
export function validateSalesAgentCommission(
  salesAgentUserId: string,
  commissionPercentInput: string,
): SalesAgentCommissionValidation {
  if (!salesAgentUserId) {
    return { ok: true, assignment: null };
  }
  const rate = rateFromPercentInput(commissionPercentInput);
  if (rate === null) {
    return { ok: false };
  }
  return {
    ok: true,
    assignment: {
      sales_agent_user_id: salesAgentUserId,
      sales_agent_commission_rate: rate,
    },
  };
}
